import { JSONSchema4 } from 'json-schema';
/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface VerifyCompanyDetailsWithGstinContract {
  success: boolean;
  addressPrefilled: boolean;
  office_address?: {
    id?: number;
    office_name?: string;
    address_line_1?: string;
    address_line_2?: string;
    state?: number;
    pincode?: string;
    is_primary?: boolean;
    [k: string]: unknown;
  };
  [k: string]: unknown;
}

export default <JSONSchema4>{
  type: 'object',
  properties: {
    success: { type: ['boolean'] },
    addressPrefilled: { type: ['boolean'] },
    office_address: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        office_name: { type: 'string' },
        address_line_1: { type: 'string' },
        address_line_2: { type: 'string' },
        state: { type: 'number' },
        pincode: { type: 'string' },
        is_primary: { type: 'boolean' },
      },
    },
  },
  required: ['success', 'addressPrefilled'],
};
